import { render, staticRenderFns } from "./pie-chart-with-legend.vue?vue&type=template&id=64cd4be4&scoped=true"
import script from "./pie-chart-with-legend.vue?vue&type=script&lang=js"
export * from "./pie-chart-with-legend.vue?vue&type=script&lang=js"
import style0 from "./pie-chart-with-legend.vue?vue&type=style&index=0&id=64cd4be4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cd4be4",
  null
  
)

export default component.exports